export default __webpack_public_path__ + "static/media/AccountingReport.0421d9cc.png";